import { S as SearchPriceSpecial } from './index2.js';
import { g as getRoomType } from './get-room-type.js';

/**
 * Native Places
 */
const factory = function factory({ document, thn }) {
    let refreshPrice = null;
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.availability-room-rates'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const filteredRooms = roomsArray.filter((room) => {
            const hasMaxOccupancy = room.querySelector('.room-rate-error');
            const hasNoAvailability = room.querySelector('.group-title')?.textContent?.match(/unavailble/);
            return !(hasMaxOccupancy || hasNoAvailability);
        });
        const roomsInfo = filteredRooms
            .map((room) => {
            const roomName = room.querySelector('h3')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.availability-rates'))
                ?.map((rate) => {
                const rateName = rate.querySelector('.group-title')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.amount')?.textContent);
                const hasBreakfast = !!rate.querySelector('.rate-description p')?.textContent?.match(/breakfast in a bag included/i);
                const isRefundable = !rate.querySelector('.rate-description p')?.textContent?.match(/Non-refundable/i);
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults || 2,
                children: 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        priceObserveDom() {
            const resultContainer = document.querySelector('.booking');
            if (resultContainer && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    const loader = thn.isVisible(document.querySelector('#loader-overlay'));
                    const calendarContainer = thn.isVisible(document.querySelector('.container-booking form'));
                    if (!loader && !calendarContainer) {
                        thn.widgets.price.refresh().catch(() => { });
                    }
                }, 400);
                thn.observeDom(resultContainer, refreshPrice, {
                    childList: true,
                    subtree: false,
                    attributes: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(resultContainer, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        onStateChange() {
            thn.debounce(thn.pageCheck, 400)();
        },
        isUserLogged() {
            const isLogged = false;
            return isLogged;
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.includes('booking');
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            // Guests, Adults & Children
            const roomNum = thn.parseNumber(document.querySelector('.room-index li[class="active"]')?.textContent) || 1;
            const children = 0;
            let adults;
            for (let i = 0; i < roomNum; i += 1) {
                adults = thn.parseNumber(document.querySelector(`[name="occupancy[${i}].adults"]`)?.value);
            }
            // Dates
            const dateBegin = thn.objectGet(window.dataLayer, 'check_in', { first: false })?.replace(/-/g, '/') ?? '';
            const dateEnd = thn.objectGet(window.dataLayer, 'check_out', { first: false })?.replace(/-/g, '/') ?? '';
            const nights = thn.daysBetween(dateBegin, dateEnd);
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Prices & Currency || No Rooms
            const pricesEl = document.querySelectorAll('.amount');
            const prices = Array.from(pricesEl).map((price) => thn.parseNumber(price?.textContent)).filter((value) => typeof value !== 'undefined');
            const minPrice = Math.min(...prices);
            const currency = thn.parseCurrency(document.querySelector('.amount')?.textContent);
            const noAvailability = document.querySelector('#error-summary')?.textContent?.match(/no availability/);
            const hasPromoCodeFail = document.querySelector('#error-summary')?.textContent?.match(/the discount code/) || false;
            const isPromoCodeApplied = document.querySelector('[name="code"]')?.value !== '';
            const priceSpecial = (hasPromoCodeFail || !isPromoCodeApplied) ? SearchPriceSpecial.None : SearchPriceSpecial.Generic;
            if (minPrice && currency && !noAvailability) {
                return {
                    adults,
                    children,
                    dateBegin,
                    dateEnd,
                    price: minPrice / nights,
                    currency,
                    priceSpecial,
                    roomDetails: roomDetailsParseData(adults),
                };
            }
            if (noAvailability) {
                return {
                    adults,
                    children,
                    dateBegin,
                    dateEnd,
                    currency,
                    noRooms: true,
                };
            }
            return null;
        },
        getPromocode(ctx) {
            const promoCode = document.querySelector('[name="code"]')?.value;
            ctx.promocode = promoCode;
            return ctx.promocode;
        },
        bookingParseData() {
            const { dataLayer } = window;
            // Booking ID
            const bookingId = thn.objectGet(dataLayer, 'booking_id', { first: false }) || document.querySelector('.booking-id')?.textContent?.split(':')[1].trim();
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Dates
            const dateBegin = thn.objectGet(dataLayer, 'check_in', { first: false })?.replace(/-/g, '/');
            const dateEnd = thn.objectGet(dataLayer, 'check_out', { first: false })?.replace(/-/g, '/');
            // Adult & Children
            const adults = thn.parseNumber(thn.objectGet(dataLayer, 'num_of_adults', { first: false })) ?? 2;
            const children = thn.parseNumber(thn.objectGet(dataLayer, 'num_of_children', { first: false })) ?? 0;
            // Price & Currency
            const price = thn.parseNumber(thn.objectGet(dataLayer, 'order_total', { first: false }));
            const currency = thn.parseCurrency(thn.objectGet(dataLayer, 'currency', { first: false }));
            return {
                bookingId,
                dateBegin,
                dateEnd,
                adults,
                children,
                price,
                currency,
            };
        },
    };
};

export { factory };
